import { useHistory } from 'react-router-dom'
import { useTranslation } from 'contexts/Localization'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import Row from 'components/Layout/Row'
import { CloseButton } from 'components/CloseButton'
import { Text, Box, Flex, Img } from 'vvs-uikit'
import historyBackOrReplace from 'utils/historyBackOrReplace'
import { Path } from 'config/constants/paths'
import { formatNumber } from 'utils/formatBalance'
import { Header } from './styles'

const QuestHistoryHeader = () => {
  const { t } = useTranslation()
  const { owner } = useGotchiOwner()
  const history = useHistory()

  return (
    <Header>
      <Row justify="flex-end">
        <CloseButton fill="black" onClick={() => historyBackOrReplace(history, Path.VVS_GOTCHI_QUEST)} />
      </Row>
      <Row>
        <Box flex="1" pr={3}>
          <Text color="black" small bold>
            {t('Quest Completed')}
          </Text>
          <StatItem type="quest" value={owner?.totalQuestCount ?? 0} />
        </Box>
        <Box flex="1" pr={3}>
          <Text color="black" small bold>
            {t('Total EXP Earned')}
          </Text>
          <StatItem type="exp" value={owner?.totalEarnedExp ?? 0} />
        </Box>
        <Box flex="1" pr={3}>
          <Text color="black" small bold>
            {t('Gacha Egg Opened')}
          </Text>
          <StatItem type="gachapon" value={owner?.gachaInfo?.gachaRecordCount ?? 0} />
        </Box>
      </Row>
    </Header>
  )
}

export default QuestHistoryHeader

const StatItem = ({ type, value }: { type: 'quest' | 'exp' | 'gachapon'; value: number }) => {
  return (
    <>
      <Flex alignItems="center" gap="0.5em" px={1} pt={2}>
        {type === 'quest' && <Img src="/images/vvsGotchi/flag.png" width="17px" />}
        {type === 'exp' && <Img src="/images/vvsGotchi/star.png" width="17px" />}
        {type === 'gachapon' && <Img src="/images/vvsGotchi/gachapon-opened.png" width="35px" />}
        <Text color="black" bold fontSize="20px">
          {formatNumber(value, 0, 3)}
        </Text>
      </Flex>
    </>
  )
}
